import { Box, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Table } from "antd";
import { useSnackbar } from "notistack";
import { LogApi } from "../../services/LogApi";
import { useAxios } from "../../contexts/AxiosProvider";

// Styled component for the log container, adjusting the margin and width based on the drawer state
const LogContainer = styled(Box)(({ openDrawer }) => ({
  marginLeft: openDrawer ? 240 : 80,
  width: openDrawer ? "calc(100% - 255px)" : "calc(100% - 85px)",
  height: "calc(100vh - 70px)",
  display: "flex",
  flexDirection: "column",
}));

// Main component for displaying log streams
const LogStream = ({ openDrawer, userData }) => {
  const params = useParams(); // Accessing URL parameters
  const axios = useAxios(); // Custom Axios instance with configurations
  const navigate = useNavigate(); // Navigation hook for programmatic navigation
  const { enqueueSnackbar } = useSnackbar(); // Snackbar for notifications
  const [loading, setLoading] = useState(false); // State for loading indicator
  const [logExecutionDatas, setLogExecutionDatas] = useState([]); // State for log data

  // Function to fetch log stream events
  const fetchLogStreamsEvent = async () => {
    try {
      setLoading(true); // Set loading to true before API call
      const data = {
        workflow_type: params.workflowType,
        log_stream_name: params.log_stream_name,
      };
      // API call to fetch log stream data
      const response = await LogApi.getLogStreamEvent(axios, data);
      if (response.status === 200) {
        setLogExecutionDatas(response.data); // Set log data if response is successful
      } else if (response.status === 204) {
        // Handle no content scenario
        setLogExecutionDatas([
          {
            log_msg: "The specified log stream does not exist",
            log_type: "No Content",
          },
        ]);
      }
    } catch (error) {
      // Handle error scenario
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false); // Set loading to false after API call is complete
    }
  };

  // useEffect to call the fetch function when the component mounts
  useEffect(() => {
    fetchLogStreamsEvent();
  }, []);

  // Columns for the log table
  const LogColumns = [
    {
      title: "LogStream Message",
      dataIndex: "log_msg",
      key: "log_msg",
      width: "80%",
      render: (text, record) => (
        <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {text}
        </div>
      ),
    },
    {
      title: "Log Type",
      dataIndex: "log_type",
      key: "log_type",
    },
  ];

  return (
    <LogContainer openDrawer={openDrawer}>
      <div
        style={{
          display: "flex",
          marginLeft: 20,
          color: "blue",
          alignItems: "center",
        }}
      >
        <Button onClick={() => navigate(-1)}>Back</Button>
        <h5 style={{ marginLeft: "10%" }}>{params.log_stream_name}</h5>
      </div>
      <div style={{ maxHeight: "85%", overflowY: "auto" }}>
        <Table
          bordered
          loading={loading}
          columns={LogColumns}
          style={{ fontWeight: "640", margin: "20px 20px" }}
          dataSource={logExecutionDatas}
          pagination={false}
        />
      </div>
    </LogContainer>
  );
};

export default LogStream;
